import styled from 'styled-components';

export const ErrorPageDiv = styled('div')``;
